import { useGalaxyAdminProducts, useGalaxyAdminCategories } from "../../hooks/useGalaxyAdminLists";
import React, { useState, useEffect, useMemo } from 'react'
import Sidebars from '../../components/sidebars/Sidebars'
import Header from '../../components/header/Header'
import Footer from '../../components/footer/Footer'
import deleteLogo from "../../assets/delete-1.png";
import viewLogo from "../../assets/view-1.png";
import editLogo from "../../assets/edit-1.png";
import deactivateLogo from "../../assets/deactivate-1.png"
import DeleteProduct from './deleteProduct/DeleteProduct'
import ViewProduct from './viewProduct/ViewProduct';
import EditProduct from './editProduct/EditProduct';
import AddProduct from './addProduct/AddProduct';
import { toast } from "react-toastify";
import LoadingAction from '../../components/Loader';
import ReactPaginate from 'react-paginate';
import { useGetCategoryQuery } from '../../Services/CategoryApi';
import { useGetProductQuery, useDeleteProductMutation } from '../../Services/ProductApi';

const ManageProduct = () => {

   const [deleteProduct] = useDeleteProductMutation();
   const [show, setShow] = useState(false);
   const [productList, setProductList] = useState([])
   const [showEdit, setShowEdit] = useState(false);
   const [showDeleteModal, setShowDeleteModal] = useState(false);
   const [showDeactivateModal, setShowDeactivateModal] = useState(false);
   const [showViewModal, setShowViewModal] = useState(false);
   const [productId, setProductId] = useState('')
   const [showLoader, setShowLoader] = useState(false);
   const [page, setPage] = useState(0)
   const [limit, setLimit] = useState(20)
   const [itemsPerPage, setItemsPerPage] = useState(20)
   const [search, setSearch] = useState('')
   const [editData, setEditData] = useState({})
  const [totalPageCount, setTotalPageCount] = useState(0)
 
   const handleClose = () => {
      setShow(false);
      setShowEdit(false);
      setShowDeleteModal(false);
      setShowDeactivateModal(false);
      setShowViewModal(false);
      setEditData({})
   };
   const deactivateShowHadler = (e) => {
      e.preventDefault();
      setShowDeactivateModal(true)
   }
   const viewShowHadler = (e, id) => {
      e.preventDefault();
      setShowViewModal(true)
      setProductId(id)
   }
   const editShowHadler = (e, id) => {
      e.preventDefault();
      setShowEdit(true)
      setProductId(id)
   }
   const deleteShowHadler = (e, id) => {
      e.preventDefault();
      setShowDeleteModal(true);
      setProductId(id)
   }
   const onProductAddedHandler = (newProduct) => {
      setProductList([...productList, newProduct]);
   };
   const handleDeleteProduct = () => {
      setShowLoader(true)
      console.log({ productId })
      deleteProduct(productId)
         .unwrap()
         .then((res) => {
            toast.success(res?.message);
            setShowLoader(false)
            refetchProducts();
         })
         .catch((err) => {
            setShowLoader(false)
            toast.error(err?.data?.message);
         });
   };
   const handlePageClick = (e) => {
 
      setPage(e.selected)
  
   }
   const handleSearch = (e) => {
      setSearch(e.target.value) 
   }
   const { data: categoriesData } = useGalaxyAdminCategories();
   const { data: products, refetch: refetchProducts } = useGalaxyAdminProducts({ page, limit, search })
   const productData = useMemo(() => products?.data?.products || [], [products?.data?.products])
   const categories = useMemo(() => categoriesData?.data?.categories || [], [categoriesData])
  useEffect(() => {
      if (products) {
        console.log('products', products)
        setTotalPageCount(products?.data?.pagination?.totalPages)
      }
   }, [products])
   useEffect(() => {
      refetchProducts({ page, limit, search })
   }, [search, page, limit])

   return (
      <>
         <Sidebars />
         <Header />
         <main id="main" className="main mt-0 h-100 min-vh-80">
            <div className="pagetitle">
               <div className="d-flex justify-content-between align-items-center mb-3 mobile-block">
                  <div className="d-flex gap-4 mobile-block">
                     <div className="div">
                        <h1>Manage Products</h1>
                        <nav>
                           <ol className="breadcrumb mb-0">
                              <li className="breadcrumb-item"><a href="">Home</a></li>
                              <li className="breadcrumb-item active">Manage Products</li>
                           </ol>
                        </nav>
                     </div>
                     <div className="search-bar mt-1">
                        <form className="d-flex" role="search">
                           <div className="border-rounded-15 border-0">
                              <div className="input-group">
                                 <input
                                    type="text"
                                    onChange={handleSearch}
                                    className="form-control border-0 bg-none" placeholder="Search..." />
                                 <span className="input-group-text bg-none border-0">
                                    <i className="b- bi-search"></i>
                                 </span>
                              </div>
                           </div>
                        </form>
                     </div>
                  </div>
                  <div className="">
                     <button className="btn btn-main me-2" onClick={(e) => setShow(true)}><i className="bi bi-plus-lg me-2"></i>Add Products</button>
                  </div>
               </div>
            </div>
            {show && (<AddProduct refetchProducts={refetchProducts} categories={categories} show={show} handleClose={handleClose} onProductAdded={onProductAddedHandler} />)}
            {showViewModal && (<ViewProduct showViewModal={showViewModal} editData={editData} handleClose={handleClose} categories={categories} />)}
            {showEdit && (<EditProduct refetchProducts={refetchProducts} editData={editData} setEditData={setEditData} showEdit={showEdit} handleClose={handleClose} categories={categories} />)}
            {showDeleteModal && (<DeleteProduct showDeleteModal={showDeleteModal} handleClose={handleClose} handleDelete={handleDeleteProduct} />)}
            <div className="container-fluid mt-2 pt-2">
               <div className="row">
                  <div className="col-md-12 px-0">
                     <div className="clearfix mb-4 mt-2">
                        <div className="float-start">
                           <h6 className="text-color fw-bolder mb-0">Products Lists</h6>
                           {/* <div className="search-bar mt-1">
                              <form className="d-flex" role="search">
                                 <div className="border-rounded-15">
                                    <div className="input-group">
                                       <input
                                          type="text"
                                          onChange={handleSearch}
                                          className="form-control border-0 bg-none" placeholder="Search..." />
                                       <span className="input-group-text bg-none border-0">
                                          <i className="b- bi-search"></i>
                                       </span>
                                    </div>
                                 </div>
                              </form>
                           </div> */}
                        </div>
                        {/* <div className="float-end">
                           <button className="btn btn-main me-2" onClick={(e) => setShow(true)}><i className="bi bi-plus-lg me-2"></i>Add Products</button>
                        </div> */}
                     </div>
                     {showLoader && <LoadingAction />}
                     <div className="card border-0 table-card">
                        <div className="card-body p-0">
                           <div className="table-responsive" style={{ 
                              overflowX: 'auto', 
                              WebkitOverflowScrolling: 'touch',
                              width: '100%',
                              display: 'block'
                           }}>
                              <table className="table table-striped mb-0 align-middle common-table" style={{ 
                                 minWidth: '800px',
                                 width: '100%',
                                 marginBottom: 0
                              }}>
                                 <thead>
                                    <tr>
                                       <th scope="col">#</th>
                                       <th scope="col">Name</th>
                                       <th scope="col">Description</th>
                                       <th scope="col">Variants</th>
                                       <th scope="col">Category</th>
                                       <th scope="col">Action</th>
                                    </tr>
                                 </thead>
                                 <tbody>
                                    {productData && productData.map((product, index) => (
                                       <tr key={index}>
                                          <th scope="row">
                                             {((page + 1) * itemsPerPage - itemsPerPage) + index + 1}
                                          </th>
                                          <td style={{
                                             width:"100px",
                                             minWidth:"100px",
                                             maxWidth:"250px",
                                             whiteSpace:"pre-wrap"
                                          }}>{product?.name || "-"}</td>
                                          <td style={{
                                             width:"100px",
                                             minWidth:"100px",
                                             maxWidth:"250px",
                                             whiteSpace:"pre-wrap"
                                          }}>{product?.description || "-"}</td>
                                          <td>
                                             {product?.variants?.length > 0 ? (
                                                <>
                                                   <div>
                                                      {product.variants[0].description} - Rate: ${product.variants[0].rate} (Qty: {product.variants[0].qty}, Price: ${product.variants[0].price})
                                                      {product.variants.length > 1 && (
                                                         <div className="dropdown d-inline ms-2">
                                                            <i
                                                               className=" dropdown-toggle"
                                                               data-bs-toggle="dropdown"
                                                               aria-expanded="false"
                                                            >
                                                            </i>
                                                            <ul className="dropdown-menu">
                                                               {product.variants.slice(1).map((variant, idx) => (
                                                                  <li key={idx}>
                                                                     <span className="dropdown-item">
                                                                        {variant?.description} - Rate: ${variant.rate} (Qty: {variant.qty}, Price: ${variant.price})
                                                                     </span>
                                                                  </li>
                                                               ))}
                                                            </ul>
                                                         </div>
                                                      )}
                                                   </div>
                                                </>
                                             ) : (
                                                "N/A"
                                             )}
                                          </td>                                
                                          <td>{product?.categories && product?.categories.map((category) => category.name).join(", ") || ""}</td>
                                          <td>
                                             <button className="btn btn-deactivate me-2 action-wh" onClick={(e) => deactivateShowHadler(e, product?._id)}>
                                                <img src={deactivateLogo} alt="Deactivate" className="img-fluid action-image" />
                                             </button>
                                             <button className="btn btn-edit me-2 action-wh" onClick={(e) => { setEditData(product); editShowHadler(e, product?.product?.productId) }}>
                                                <img src={editLogo} alt="Edit" className="img-fluid action-image" />
                                             </button>                                           
                                             <button className="btn btn-delete me-2 action-wh" onClick={(e) => deleteShowHadler(e, product?.productId)}>
                                                <img src={deleteLogo} alt="Delete" className="img-fluid action-image" />
                                             </button>
                                          </td>
                                       </tr>
                                    ))}
                                 </tbody>
                              </table>

                              {productData?.length == 0 && <span className="no-data my-4 fw-bold"><p>No Data Found</p></span>}
                           </div>
                           {productData?.length > 0 &&
                               <ReactPaginate
                                 breakLabel="..."
                                 breakClassName={'break'}
                                 nextLabel=" >"
                                 containerClassName={"pagination"}
                                 activeClassName={"active"}
                                 onPageChange={handlePageClick}
                                 forcePage={page}
                                 pageRangeDisplayed={5}
                                 marginPagesDisplayed={1}
                                 pageCount={totalPageCount}
                                 previousLabel="< "
                                 renderOnZeroPageCount={null}
                              />
                           }
                        </div>
                     </div>
                  </div>
               </div>

            </div>
         </main>
         <Footer />
      </>
   )
}

export default ManageProduct